import { ChartType, Plugin, Tick } from "chart.js";

export function createYAxisLabelBackgroundPlugin<T extends ChartType>({
  id = "yAxisLabelBackground",
  labelColors,
}: {
  id?: string;
  labelColors: (string | null | undefined)[];
}): Plugin<T> {
  return {
    id,
    afterDraw(chart) {
      const ctx = chart.ctx;
      const yScale = chart.scales.y;

      ctx.font = "400 13px";
      ctx.textAlign = "right"; // right-aligned text
      ctx.textBaseline = "middle";

      yScale.ticks.forEach((tick: Tick, index: number) => {
        const label = tick.label as string;
        const labelY = yScale.getPixelForTick(index);
        const labelX = yScale.right - 9; // align to the left edge of the chart
        const paddingX = 4;
        const paddingY = 0;
        const radius = 6;

        const color = labelColors[index];
        if (!color) return;

        const textWidth = ctx.measureText(label).width;
        const textHeight = 20;
        const rectWidth = textWidth + paddingX * 2;
        const rectHeight = textHeight + paddingY * 2;

        const rectX = labelX - rectWidth; // shift rect left from tick line
        const rectY = labelY - rectHeight / 2;

        ctx.save();

        // Background
        ctx.fillStyle = color;
        ctx.strokeStyle = "transparent";
        ctx.lineWidth = 1;

        ctx.beginPath();
        ctx.moveTo(rectX + radius, rectY);
        ctx.lineTo(rectX + rectWidth - radius, rectY);
        ctx.quadraticCurveTo(
          rectX + rectWidth,
          rectY,
          rectX + rectWidth,
          rectY + radius
        );
        ctx.lineTo(rectX + rectWidth, rectY + rectHeight - radius);
        ctx.quadraticCurveTo(
          rectX + rectWidth,
          rectY + rectHeight,
          rectX + rectWidth - radius,
          rectY + rectHeight
        );
        ctx.lineTo(rectX + radius, rectY + rectHeight);
        ctx.quadraticCurveTo(
          rectX,
          rectY + rectHeight,
          rectX,
          rectY + rectHeight - radius
        );
        ctx.lineTo(rectX, rectY + radius);
        ctx.quadraticCurveTo(rectX, rectY, rectX + radius, rectY);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();

        // Text (right-aligned)
        ctx.fillStyle = index === 1 || index === 2 ? "black" : "white"; // Text color
        ctx.fillText(label, labelX - paddingX, labelY); // align to right edge of background

        ctx.restore();
      });
    },
  };
}
